/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SnippetPreviewCandidate {
  candidate_id: string;
  full_name: string;
  current_title?: string | null;
  current_company?: string | null;
  avatar_url?: string | null;
}
